export default __webpack_public_path__ + "static/media/additional_grey.b7f06586.svg";